import { render, staticRenderFns } from "./yiliaofuwu_bqhf.vue?vue&type=template&id=58271ff7&scoped=true"
import script from "./yiliaofuwu_bqhf.vue?vue&type=script&lang=js"
export * from "./yiliaofuwu_bqhf.vue?vue&type=script&lang=js"
import style0 from "./yiliaofuwu_bqhf.vue?vue&type=style&index=0&id=58271ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58271ff7",
  null
  
)

export default component.exports